// Mini-dictionary for the tutorial sandbox only (template: к, о, т).
// All words are nouns with к·о·т in order, length ≥ 4, stored normalised (lowercase, ё→е).
// This is NOT the game dictionary — just a handful for demonstration.
export const SANDBOX_WORDS_KOT: ReadonlySet<string> = new Set([
  'крот',
  'капот',
  'компот',
  'скотч',
  'кашалот',
  'эскорт',
  'котлета',
]);
